import React, { useState, useLayoutEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { AdmPainelComponentsProps } from 'types/AdmPainelComponentsProps';
import Load from 'components/Load';
import { UseTranslationProps } from 'types/UseTranslationProps';
import { getComponents } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import SwitchToggle from 'components/Buttons/SwitchToggleGeneral';
import { toggleComponent } from './reqs';
import AccordionWithTitle from 'components/AccordionWithTitle';

interface ComponentsAdmProps {
	isVisiable: boolean;
}

export default function ComponentsAdm({ isVisiable }: ComponentsAdmProps) {
	const { t }: UseTranslationProps = useTranslation();
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [accordionIsOpen, setAccordionIsOpen] = useState(false);
	const [isReqComponents, setIsReqComponents] = useState(false);
	const [listComponents, setListComponents] = useState<
		AdmPainelComponentsProps[]
	>([]);

	async function handleToogleComponent(flag: AdmPainelComponentsProps) {
		setIsOpenLoad(true);
		setMessage('Atualizando o status do componente');

		const { data, isSuccess } = await toggleComponent(flag, handleNotify);

		if (isSuccess && data) {
			const newList = listComponents.map((item) => {
				if (item.id === flag.id) {
					return data;
				}

				return item;
			});

			setListComponents(newList);
		}

		setIsOpenLoad(false);
	}

	// gera o controller dos accordions se ele estão abertos ou não
	useLayoutEffect(() => {
		(async () => {
			setIsReqComponents(true);
			const { data, isSuccess } = await getComponents(handleNotify);
			setIsReqComponents(false);

			if (isSuccess && data.length > 0) {
				setListComponents(data);
			}
		})();
	}, []);

	return (
		<S.container $isShow={isVisiable}>
			{isReqComponents ? (
				<S.centralize>
					<Load showText text="Carregando componentes" />
				</S.centralize>
			) : (
				<>
					{listComponents.length > 0 ? (
						<AccordionWithTitle
							setOpen={setAccordionIsOpen}
							open={accordionIsOpen}
							title="Páginas dinâmicas"
							contrastItem={false}
						>
							<S.listFlags>
								{listComponents.map((flag) => (
									<S.flag key={flag.id}>
										<SwitchToggle
											style={{ transform: 'translateY(-1px)' }}
											isChecked={
												typeof flag.active === 'boolean' ? flag.active : false
											} //só uma verificação para garantir, por que há casos que virá uma string
											setIsChecked={async () => {
												await handleToogleComponent(flag);
											}}
										/>
										<p>{flag.name}</p>
									</S.flag>
								))}
							</S.listFlags>
						</AccordionWithTitle>
					) : (
						<S.centralize>
							<p>{t('Lista vázia')}</p>
						</S.centralize>
					)}
				</>
			)}
		</S.container>
	);
}
